module.exports = __webpack_public_path__ + "img/cast_ic_sme.173c9c4f.svg";